import { PeriodType } from 'consts/consts';

import en from './strings.en';

const ru = {
    [PeriodType.day]: {
        title: '1 день',
        accessDescription: 'Доступ сегодня до 23:59',
    },
    [PeriodType.month]: {
        title: '1 месяц',
        accessDescription: 'Доступ на 30 дней'
    },
    profit: 'Выгода {{percent}}%',
    price: '<atis>{{personal}}\u00a0ат. </atis> <gray>/</gray> <rub>{{personal}}\u00a0₽</rub>',
    discountPrice: '<atis>{{personal}} <cross>{{base}}</cross> \u00a0 ат. </atis> <gray>/</gray> <rub>{{personal}} <cross>{{base}}</cross>\u00a0₽</rub>',
    discount: 'скидка',
};

export default { ru, en: { ...ru, ...en} };
